import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgIconOpenlinkOutlined = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" viewBox="0 0 32 32" aria-hidden={!title && !titleId} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" fillRule="evenodd" d="M7.458 8.014a1 1 0 0 0 1 1H22.07L6.808 24.277a1 1 0 1 0 1.414 1.414l15.263-15.263V24.04a1 1 0 1 0 2 0V8.014a1 1 0 0 0-1-1H8.458a1 1 0 0 0-1 1" clipRule="evenodd" /></svg>;
export default SvgIconOpenlinkOutlined;